// removed by extract-text-webpack-plugin
module.exports = {"container":"_21gwpEPJJYaqjHQXoLqd0c","cardGroup":"_26thXAAI4QFk6ZSHdIYF-P","item":"_2zuu-NuCWfvzo-mY2o_v5t","header":"NSmQk_6p3A9VaNi5uxlS3"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/manager/pages/ManagersPage.scss
// module id = 663
// module chunks = 0